import { useState } from "react";
import { sendPasswordResetEmail, getAuth } from "firebase/auth";
import { auth } from "./firebase";
import "./LogIn.css";
import { Link, useNavigate } from "react-router-dom";
import { useAlert } from "react-alert";
const ForgotPassword = () => {
  const alert = useAlert();
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const handleSubmit = (event) => {
    event.preventDefault();
    sendPasswordResetEmail(auth, email)
      .then(() => {
        alert.show(
          "Email has been sent to you for your password reset" +
            " \n\n Click Ok to continue ...."
        );
        navigate("/NewPasswordLogin");
      })
      .catch((error) => {
        alert.show(
          "Invalid email ....\n\nEnter the correct email used to register"
        );
      });
  };
  return (
    <div className="login">
      <div className="login_container">
        <h3> I forgot My Password</h3>
        <form>
          <p>
            <br />
            <h4>Enter your existing E-mail and click Reset :</h4>
          </p>

          <input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button
            className="login_signInButton"
            type="submit"
            title="if you have already created an account please enter the existing email and password to log in"
            onClick={(event) => handleSubmit(event)}
          >
            Reset my existing password
          </button>
          <p>
            <br />
            By continuing, you agree to :{`${process.env.REACT_APP_SITE_TITLE}`}
            Conditions of Use and Privacy Notice.
          </p>
          <br />
          <Link to="/login">
            <div className="close">Close</div>
          </Link>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
